import { faCheckCircle, faCirclePlus, faEdit, faSearch, faTimes, faTruckFast, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { IEntregas, IFilterEntregasDTO, IPessoas, IVeiculos } from "../../global/types"
import Modal from "react-modal"
import { useAdmContext } from "../../hooks/useAdmContext"
import "./style.css"
import { defaultModalStyle } from "../../utils/defaultModalStyle"
import { VeiculosModal } from "../../modals/VeiculosModal"
import { PessoasModal } from "../../modals/PessoasModal"
import { convertDateSqlToDate, convertDateToBr, convertToUs } from "../../utils/dateProvider"
import { api } from "../../services/api"
import { Pagination } from "../../components/Pagination"
import { DetalheEntregaModal } from "../../modals/DetalheEntregaModal"
import { maskNumber } from "../../utils/masks"

const defaultFilters = {
  veiculo: {} as IVeiculos,
  motorista: {} as IPessoas,
  ajudante: {} as IPessoas,
  data: "",
  entrada: "",
  saida: ""
}

export function Entregas() {
  const navigate = useNavigate()
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [list, setList] = useState<IEntregas[]>([])

  const [pesquisa, setPesquisa] = useState<IFilterEntregasDTO>(defaultFilters)

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  // const [limitPage, setLimitPage] = useState(25);
  const limitPage = 25

  const [modalVeiculo, setModalVeiculo] = useState(false)
  const [modalMotorista, setModalMotorista] = useState(false)
  const [modalAjudante, setModalAjudante] = useState(false)
  const [modalDetalhe, setModalDetalhe] = useState(false)

  const [detalheEntrega, setDetalheEntrega] = useState<IEntregas>({} as IEntregas)

  const handleSelectVeiculo = (veiculo: IVeiculos) => {
    setPesquisa(e => ({ ...e, veiculo }))
  }

  const handleSelectMotorista = (motorista: IPessoas) => {
    setPesquisa(e => ({ ...e, motorista }))
  }

  const handleSelectAjudante = (ajudante: IPessoas) => {
    setPesquisa(e => ({ ...e, ajudante }))
  }

  const handleOpenDetalhe = (item: IEntregas) => {
    if (item.saida === "00:00:00")
      return

    setDetalheEntrega(item)
    setModalDetalhe(true)
  }

  const loadList = useCallback(async (pesq?: IFilterEntregasDTO) => {
    setLoading(true)
    setTxtLoading("Carregando lista de Entregas...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.post("entregas/all", {
      cursor: (limitPage * page) - limitPage,
      limit: limitPage,
      pesquisa: {
        id_veiculo: pesq?.veiculo ? pesq?.veiculo.id : null,
        id_motorista: pesq?.motorista ? pesq?.motorista.id : null,
        id_ajudante: pesq?.ajudante ? pesq?.ajudante.id : null,
        data: pesq?.data && pesq?.data.length === 10 ? `${convertToUs(pesq?.data)} 00:00:00` : null,
        entrada: null,
        saida: null
      }
    })
      .then((res) => {
        if (!res.data)
          return

        setList(res.data.result)

        const newMaxPage = Math.ceil(res.data.total / limitPage);
        setMaxPage(newMaxPage < 1 ? 1 : newMaxPage);
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar lista de entregas. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, page])

  useEffect(() => {
    if (tokens?.token)
      loadList()
  }, [tokens, page, loadList])

  useEffect(() => {
    Modal.setAppElement("body")
  }, [])

  return (
    <div id="pgEntregas">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="topo">
            <div style={{ flex: 1 }} />
            <button onClick={() => navigate("novo")} className="btnNovo btn-green">
              <FontAwesomeIcon icon={faCirclePlus} />
              NOVO
            </button>
          </div>

          <div className="painel">
            <p className="title">Pesquisa</p>

            <div className="bodyFilter">

              <div style={{ width: "32%" }} >
                <label>Veículo:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.veiculo?.nome ? pesquisa.veiculo.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Veículo"
                    readOnly
                  />
                  {pesquisa.veiculo?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, veiculo: {} as IVeiculos }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalVeiculo(true)}>
                    <FontAwesomeIcon icon={faTruckFast} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Motorista:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.motorista?.nome ? pesquisa.motorista.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Motorista"
                    readOnly
                  />
                  {pesquisa.motorista?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, motorista: {} as IPessoas }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalMotorista(true)}>
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Ajudante:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.ajudante?.nome ? pesquisa.ajudante.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Ajudante"
                    readOnly
                  />
                  {pesquisa.ajudante?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, ajudante: {} as IPessoas }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalAjudante(true)}>
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Data</label>
                <Input
                  mask="date"
                  value={pesquisa.data}
                  inputMaskChange={(v) => setPesquisa(e => ({ ...e, data: v }))}
                  placeholder="Pesquisa por Data"
                  maxLength={10}
                />
              </div>

              <div style={{ width: "100%" }}>
                <button className="btn-blue" style={{ margin: "0 auto" }} onClick={() => loadList(pesquisa)}>
                  <FontAwesomeIcon icon={faSearch} />
                  Pesquisar
                </button>
              </div>

            </div>
          </div>

          <div className="painel table">
            <div className="head">
              <span style={{ width: "50px" }}></span>
              <span style={{ width: "50px" }} />
              <span style={{ flex: '1' }}>Roteiro</span>
              <span style={{ flex: '1' }}>Data</span>
              <span style={{ flex: '2' }}>Veículo</span>
              <span style={{ flex: '2' }}>Motorista</span>
              <span style={{ flex: '2' }}>Ajudante</span>
            </div>

            <div className="tableContent">
              {list && list.map(item => (
                <div
                  key={item.id}
                  className="rowTable"
                  style={{ background: item.saida !== "00:00:00" ? "#b9e5b4" : "#FFF" }}
                  onClick={() => handleOpenDetalhe(item)}
                >
                  <button className="btn-purple btnSmall" onClick={() => navigate(`${item.id}`)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </button>

                  <span style={{ width: '50px', textAlign: "center" }}>
                    {item.saida !== "00:00:00" ? <FontAwesomeIcon icon={faCheckCircle} fontSize="28px" color="#00bcf1" /> : ""}
                  </span>
                  <span style={{ flex: '1' }}>{maskNumber(`${item.roteiro}`)}</span>
                  <span style={{ flex: '1' }}>{convertDateToBr(convertDateSqlToDate(`${item.data}`))}</span>
                  <span style={{ flex: '2' }}>{item.veiculo.nome}</span>
                  <span style={{ flex: '2' }}>{item.motorista.nome}</span>
                  <span style={{ flex: '2' }}>
                    {item.ajudante ? item.ajudante.nome : ""}
                    {item.freelancers && item.freelancers.filter(e => e.funcao === 0).map((rs, i) => (
                      i > 0 || item.ajudante?.nome ? ` / ${rs.pessoa.nome}` : rs.pessoa.nome
                    ))}
                  </span>

                </div>
              ))}
            </div>

          </div>

          <Pagination maxPage={maxPage} page={page} setPage={setPage} />

        </>
      )}

      <Modal isOpen={modalVeiculo} style={defaultModalStyle}>
        <VeiculosModal closeModal={() => setModalVeiculo(false)} handleSelect={(e) => handleSelectVeiculo(e)} />
      </Modal>

      <Modal isOpen={modalMotorista} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalMotorista(false)} handleSelect={(e) => handleSelectMotorista(e)} />
      </Modal>

      <Modal isOpen={modalAjudante} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalAjudante(false)} handleSelect={(e) => handleSelectAjudante(e)} />
      </Modal>

      <Modal isOpen={modalDetalhe} style={defaultModalStyle}>
        <DetalheEntregaModal closeModal={() => setModalDetalhe(false)} entrega={detalheEntrega} />
      </Modal>

    </div>
  )
}